export class NotificationAllocationRequestType {
	public index;
	
	constructor(obj) {
		this.index = obj.index;
	}
} 
